import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Cliente from '../cliente/cliente';
import Produto from '../produto/produto';
import PedidoHistoricoForm from '../pedido/pedidoHistoricoForm';

import {
	setModoTela, initForm,
	initFormHistorico, getListaHistoricos, salvarHistorico, excluirHistorico
} from './solicitacaoCompraActions';
import consts from '../consts';
import FileUtils from '../common/fileUtils/FileUtils';

class SolicitacaoCompraForm extends Component {

	state = {

	}

    componentWillMount() {
		this.props.getListaHistoricos(this.props.formularioValues.numero)
    }

    render() {

		let readOnly = this.props.excluir || this.props.cancelar ? 'readOnly' : '';

		
		return (
			<>
				<ContentCard>

					{this.modalCliente()}

					{this.modalProduto()}

					{this.props.formularioValues.numero ? (
						<Row>
							<Grid cols='12 12 12 12'>
								<label style={{ paddingTop: 16, paddingLeft: 8, fontSize: 18 }}>Número: {this.props.formularioValues.numero}</label>
							</Grid>
						</Row>
					) : null}
					
					{!this.props.formularioValues.formAberto &&
					<>
						<ContentCardBody>
							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>Data/Hora</Th>
										<Th alignCenter>Tipo</Th>
										<Th alignCenter>Categoria</Th>
										<Th alignCenter>Prioridade</Th>
										<Th alignCenter>Cliente</Th>
										<Th alignCenter>Produto</Th>
										<Th alignCenter>Quantidade</Th>
										<Th alignCenter>Prazo</Th>
										<Th alignCenter>Status</Th>
										<Th alignCenter>Usuário</Th>
										<Th></Th>
									</Tr>
								</THead>
								<TBody>
									{this.props.lista.filter(item => item.numero == this.props.formularioValues.numero).map(item => {

										let prazo = parseInt(item.prazo || 0) - parseInt(item.dias_abertura || 0);

										return (
											<Tr key={item.id}>
												<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao)}</Td>
												<Td alignCenter small>{item.nome_tipo}</Td>
												<Td alignCenter small>{item.nome_categoria}</Td>
												<Td alignCenter small>
													<span class='badge badge-success' style={{ backgroundColor: item.cor_prioridade, fontSize: 12 }}>{item.nome_prioridade}</span>
												</Td>
												<Td alignCenter small>{item.nome_cliente}</Td>
												<Td alignCenter small>{item.nome_produto}</Td>
												<Td alignCenter small>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
												<Td alignCenter small color={prazo <= 0 ? '#b50000' : '#000000'}>{
													prazo > 0 ? `Falta${prazo == 1 ? '' : 'm'} ${prazo} dia${prazo == 1 ? '' : 's'}`
													: (prazo == 0 ? 'Venceu hoje' : `Vencido há ${prazo * -1} dia${prazo == -1 ? '' : 's'}`)
												}</Td>
												<Td alignCenter small>{item.nome_status_pedido || 'Aguardando Pedido'}</Td>
												<Td alignCenter small>{item.nome_usuario}</Td>
												<Td alignRight minWidth={150}>
													<ButtonTable
														type={'warning'}
														icon={'fas fa-pencil-alt'}
														visible={true}
														disabled={item.nome_status_pedido}
														title={item.nome_status_pedido ? 'Não é possível alterar com pedido aberto' : ''}
														event={() => {
															this.props.setModoTela('cadastro');
															this.props.initForm({
																...item,
																quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
																prazo: FormatUtils.formatarValorTela(item.prazo, 0),
																datahora_cancelamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_cancelamento),
																formAberto: true
															});
														}} />
														
													<ButtonTable
														type={'danger'}
														icon={'fas fa-ban'}
														visible={true}
														disabled={item.nome_status_pedido}
														title={item.nome_status_pedido ? 'Não é possível calcelar com pedido aberto' : 'Cancelar'}
														event={() => {
															this.props.setModoTela('cancelamento');
															this.props.initForm({
																...item,
																quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
																prazo: FormatUtils.formatarValorTela(item.prazo, 0),
																datahora_cancelamento: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
																id_usuario_cancelamento: this.props.sessao.id,
																formAberto: true
															});
														}} />

													<ButtonTable
														type={'danger'}
														icon={'fas fa-trash-alt'}
														visible={true}
														disabled={item.nome_status_pedido}
														title={item.nome_status_pedido ? 'Não é possível excluir com pedido aberto' : ''}
														event={() => {
															this.props.setModoTela('exclusao');
															this.props.initForm({
																...item,
																quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
																prazo: FormatUtils.formatarValorTela(item.prazo, 0),
																datahora_cancelamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_cancelamento),
																formAberto: true
															});
														}} />
												</Td>
											</Tr>
										)
									})}
								</TBody>
							</Table>
						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								{!this.props.excluir &&
								<Grid cols='6 6 4 3'>
									<Button
										text='Adicionar'
										type={'success'}
										icon={'fa fa-chevron-left'}
										event={() => {
											let lista = this.props.lista.filter(item => item.numero == this.props.formularioValues.numero);
											let registro = lista[lista.length - 1] || {};
											this.props.setModoTela('cadastro');
											this.props.initForm({
												numero: registro.numero,
												id_tipo: registro.id_tipo,
												id_categoria: registro.id_categoria,
												id_prioridade: registro.id_prioridade,
												id_cliente: registro.id_cliente,
												formAberto: true
											});
										}} />
								</Grid>}
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</>}

					{this.props.formularioValues.formAberto &&
					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>
								
								<Field
									name='id_tipo'
									component={Select}
									label='Tipo' placeholder='Informe'
									options={this.props.listaTipo}
									cols='12 6 4 4'
									readOnly={readOnly} />

								<Field
									name='id_categoria'
									component={Select}
									label='Categoria' placeholder='Informe'
									options={this.props.listaCategoria}
									cols='12 6 4 4'
									readOnly={readOnly} />
								
								<Field
									name='id_prioridade'
									component={Select}
									label='Prioridade' placeholder='Informe'
									options={this.props.listaPrioridade}
									cols='12 6 4 4'
									readOnly={readOnly} />
								
								<Field
									name='id_cliente'
									component={Select}
									label='Cliente' placeholder='Informe'
									options={this.props.listaCliente}
									cols='8 10 10 10'
									readOnly={readOnly} />
								
								{(this.props.usuarioCarregado && this.props.usuarioCarregado.permissao_cadastro) &&
								<Grid cols='4 2 2 2'>
									<a class='btn btn-app bg-secondary' style={{ height: 67 }}
										onClick={() => this.setState({ ...this.state, modalCliente: true })}>
										<i class='fas fa-user-tie'></i> Cadastro
									</a>
								</Grid>}

								<Field
									name='id_produto'
									component={Select}
									label='Produto' placeholder='Informe'
									options={this.props.listaProduto}
									cols='8 10 10 10'
									readOnly={readOnly} />
								
								{(this.props.usuarioCarregado && this.props.usuarioCarregado.permissao_cadastro) &&
								<Grid cols='4 2 2 2'>
									<a class='btn btn-app bg-secondary' style={{ height: 67 }}
										onClick={() => this.setState({ ...this.state, modalProduto: true })}>
										<i class='fas fa-table'></i> Cadastro
									</a>
								</Grid>}

								<Field
									name='quantidade'
									component={LabelAndInputNumber}
									label='Quantidade' placeholder='Informe'
									cols='12 6 4 3'
									casas={2}
									readOnly={readOnly} />

								<Field
									name='prazo'
									component={LabelAndInputNumber}
									label='Prazo' placeholder='Informe'
									cols='12 6 4 3'
									casas={0}
									readOnly={readOnly} />

							</Row>
							
							{this.props.cancelar &&
							<Row>
								<Field
									name='descricao_cancelamento'
									component={LabelAndInput}
									label='Motivo do Cancelamento' placeholder='Informe'
									cols='12 12 12 12' />
							</Row>}

						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								<Grid cols='6 6 4 3'>
									{this.props.excluir ? (
										<Button
											text='Excluir'
											submit type={'danger'}
											icon={'fa fa-trash'} />
									) : (
									<Button
										text={this.props.cancelar ? 'Cancelar' : (this.props.formularioValues.id ? 'Salvar' : 'Adicionar')}
										submit
										disabled={this.props.cancelar && (this.props.formularioValues.descricao_cancelamento || '').length < 4}
										type={this.props.cancelar ? 'danger' : 'success'}
										icon={'fa fa-check'} />
									)}
								</Grid>
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => {
											this.props.initForm({
												...this.props.formularioValues,
												formAberto: false
											});
										}} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</Form>}
				</ContentCard>
				

				{(this.props.formularioValues.numero && !this.props.excluir && !this.props.cancelamento) &&
				this.historicos()}

			</>
		);
    }

	modalCliente() {

		if (!this.state.modalCliente) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Cliente</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalCliente: false })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Cliente />
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => this.setState({ ...this.state, modalCliente: false })}>Fechar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalProduto() {

		if (!this.state.modalProduto) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Produto</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalProduto: false })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Produto />
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => this.setState({ ...this.state, modalProduto: false })}>Fechar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	historicos() {

		return (
			<div class='card'>
				<div class='card-header p-2'>

					{!this.props.formularioValuesHistorico &&
					<a class='btn btn-app bg-secondary'
						onClick={() => this.props.initFormHistorico({ numero_solicitacao: this.props.formularioValues.numero })}>
						<i class='fas fa-comments'></i> Adicionar 
					</a>}

					{(this.props.formularioValuesHistorico && !this.props.formularioValuesHistorico.id) &&
					<PedidoHistoricoForm onSubmit={this.props.formularioValuesHistorico.excluir ? this.props.excluirHistorico : this.props.salvarHistorico} />}
                
				</div>

				<div>
					<div class='tab-content'>
						{this.props.listaHistoricos.map(item => {

							return (
								<div
									style={{
										borderBottom: '1px solid #adb5bd',
										paddingTop: 8,
										paddingLeft: 16,
										paddingBottom: 8,
										paddingRight: 16
									}}>
									<div 
										style={{ 
											display: 'flex',
											justifyContent: 'space-between',
											marginBottom: 8
										}}>
										<strong>{item.nome_usuario}</strong>

										<div	
											style={{ 
												display: 'flex',
												justifyContent: 'flex-end'
											}}>
											{item.id_usuario_inclusao == this.props.sessao.id &&											
											<a class='float-right btn-tool'
												style={{
													paddingTop: 12,
													color: '#6c757d'
												}}
												onClick={() => {
													this.props.initFormHistorico({
														...item,
														id_pedido: this.props.formularioValues.id,
														excluir: false
													});
												}}><i class='fas fa-pencil-alt'></i></a>}
											
											{item.id_usuario_inclusao == this.props.sessao.id &&
											<a class='float-right btn-tool'
												style={{
													paddingTop: 12,
													marginRight: 16,
													color: '#6c757d'
												}}
												onClick={() => {
													this.props.initFormHistorico({
														...item,
														id_pedido: this.props.formularioValues.id,
														excluir: true
													});
												}}><i class='fas fa-trash'></i></a>}
											
											<div
												style={{
													color: '#6c757d'
												}}>
												{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}
											</div>
										</div>										
									</div>
									{(this.props.formularioValuesHistorico && this.props.formularioValuesHistorico.id == item.id) ? (
										<PedidoHistoricoForm onSubmit={this.props.formularioValuesHistorico.excluir ? this.props.excluirHistorico : this.props.salvarHistorico} />
									) : (
										<div
											style={{
												backgroundColor: '#f2f0f0',
												padding: 8,
												borderRadius: 10
											}}>
											{(item.descricao || '').split('\n').map(linha => (
												<p key={{linha}} style={{ padding: 0, margin: 0 }}>{linha}</p>
											))}
											{(item.anexos || []).length > 0 &&
											<p style={{ marginTop: 16, marginBottom: 0, paddingBottom: 0 }}>
												{(item.anexos || []).map(anexo => (
													<a key={anexo} class='btn btn-app bg-secondary'
														style={{ height: 30, width: 30, minWidth: 30, paddingTop: 4, marginLeft: 0, marginRight: 4, marginBottom: 0 }}
														onClick={() => window.open(`${consts.URL}/${anexo.arquivo}`, '_blank')}>
														<i class={FileUtils.getFontAwesomeIconePeloNome(anexo.arquivo)}></i>
													</a>
												))}
											</p>}
										</div>
									)}
								</div>
							);
						})}
					</div>
				</div>
				
				{/*<div class='card-body'>
					<div class='tab-content'>
						<div class='active tab-pane' id='activity'>
							{this.props.listaHistoricos.map(item => {

								return (
									<div key={item.id} class='post'>
										<div class='user-block'>
											<span class='username' style={{ marginLeft: 0 }}>
												<strong>{item.nome_usuario}</strong>
												{item.id_usuario_inclusao == this.props.sessao.id &&
												<a class='float-right btn-tool'
													onClick={() => {
														this.props.initFormHistorico({
															...item,
															excluir: false
														});
													}}><i class='fas fa-pencil-alt'></i></a>}
												{item.id_usuario_inclusao == this.props.sessao.id &&
												<a class='float-right btn-tool'
													onClick={() => {
														this.props.initFormHistorico({
															...item,
															excluir: true
														});
													}}><i class='fas fa-trash'></i></a>}
											</span>
											<span class='description' style={{ marginLeft: 0 }}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</span>
										</div>
										{(this.props.formularioValuesHistorico && this.props.formularioValuesHistorico.id == item.id) ? (
											<PedidoHistoricoForm onSubmit={this.props.formularioValuesHistorico.excluir ? this.props.excluirHistorico : this.props.salvarHistorico} />
										) : (
											<>
												{(item.descricao || '').split('\n').map(linha => (
													<p key={{linha}} style={{ padding: 0, margin: 0 }}>{linha}</p>
												))}
												<p style={{ marginTop: 16, marginBottom: 0, paddingBottom: 0 }}>
													{(item.anexos || []).map(anexo => (
														<a key={anexo} class='btn btn-app bg-secondary'
															style={{ height: 30, width: 30, minWidth: 30, paddingTop: 4 }}
															onClick={() => window.open(`${consts.URL}/${anexo.arquivo}`, '_blank')}>
															<i class='fas fa-file-download'></i> 
														</a>
													))}
												</p>
											</>
										)}
									</div>
								);
							})}
						</div>
					</div>
				</div>*/}
			</div>
		);
	}


}

SolicitacaoCompraForm = reduxForm({form: 'solicitacaoCompraForm', destroyOnUnmount: false})(SolicitacaoCompraForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('solicitacaoCompraForm')(state),
	formularioValuesHistorico: getFormValues('pedidoHistoricoForm')(state),
	registro: state.solicitacaoCompra.registro,
	lista: state.solicitacaoCompra.lista.filter(item => {
		if (state.auth.usuarioCarregado && (
			state.auth.usuarioCarregado.permissao_gerencia_compra
			|| state.auth.usuarioCarregado.permissao_visualiza_compra
		)) {
			return true;
		} else {
			return item.id_usuario_inclusao == state.auth.usuario.id;
		}
	}),
	listaHistoricos: state.solicitacaoCompra.listaHistoricos,
	listaTipo: state.compraTipo.listaSelect,	
	listaCategoria: state.compraCategoria.listaSelect,
	listaCliente: state.cliente.listaSelect,
	listaProduto: state.produto.listaSelect,
	listaPrioridade: state.prioridade.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm,
	initFormHistorico, getListaHistoricos, salvarHistorico, excluirHistorico
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SolicitacaoCompraForm);
